import { http } from "../../../shared/api/http"

export type CategoryItem = {
  id: string
  title: string
  codename: string
  parent_id?: string | null
}

export type CategoryListResponse = {
  items: CategoryItem[]
  total: number
}

export type CreateCategoryPayload = {
  title: string
  codename: string
}

export type UpdateCategoryPayload = {
  title?: string
  codename?: string
}

export const listCategoriesApi = (
  limit = 100,
  offset = 0
) => {
  return http.get<CategoryListResponse>(
    "/api/categories",
    {
      params: { limit, offset },
    }
  )
}

export const createCategoryApi = (
  data: CreateCategoryPayload
) => {
  return http.post<{ id: string }>(
    "/api/admin/categories/create",
    data
  )
}


export const updateCategoryApi = (
  categoryId: string,
  data: UpdateCategoryPayload
) =>
  http.patch<CategoryItem>(
    `/api/admin/categories/${categoryId}/update`,
    data
  )

export const deleteCategoryApi = (
  categoryId: string
) =>
  http.delete<{ success: boolean }>(
    `/api/admin/categories/${categoryId}/delete`
  )